export function colorContrast(color: string, darkTextDefault: string, lightTextDefault: string): string {
  const isValidHex = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/i.test(color);
  if (!isValidHex) {
    return darkTextDefault;
  }

  if (color.length === 4) {
    color = `#${color[1]}${color[1]}${color[2]}${color[2]}${color[3]}${color[3]}`;
  }

  const red = parseInt(color.substring(1, 3), 16);
  const green = parseInt(color.substring(3, 5), 16);
  const blue = parseInt(color.substring(5, 7), 16);

  const luminance = (channel: number) => {
    const c = channel / 255;
    return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
  };

  const r = luminance(red);
  const g = luminance(green);
  const b = luminance(blue);
  const relativeLuminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;
  return relativeLuminance > 0.179 ? darkTextDefault : lightTextDefault;
}
